import { render, staticRenderFns } from "./ImgLightBox.vue?vue&type=template&id=51b21bcf&scoped=true"
import script from "./ImgLightBox.vue?vue&type=script&lang=js"
export * from "./ImgLightBox.vue?vue&type=script&lang=js"
import style0 from "./ImgLightBox.vue?vue&type=style&index=0&id=51b21bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b21bcf",
  null
  
)

export default component.exports